import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';


class FrmPdf extends Component {
  constructor(props) {
    super(props); 
    this.state={
      pdfurl:''
    }   
  }


  componentDidMount()
  {       
    var storage_session=JSON.parse(localStorage.getItem('localstorageval'));
    if(storage_session)
    {
      this.setState({pdfurl:this.props.location.state.pdffilename});
    }
    else{
      localStorage.removeItem('localstorageval');
      localStorage.removeItem('selectedmenu', '');
      browserHistory.push('/');
    }
  }

  render() {
  
    return (
      <div className="container">

        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper">
           <div>            
            <object data={App_data.frontend_url+"/pdf/frm/"+this.state.pdfurl} 
            type="application/pdf"  style={{height: 100 + 'vh', width: 100 + '%'}}></object>
          </div>
           
          </div>
        </div>
        
      </div>
    );
  }
}

export default FrmPdf;



// WEBPACK FOOTER //
// ./src/views/Pages/FrmPdf/FrmPdf.js